var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-channel-code" }, [
    _c(
      "div",
      { staticClass: "tabs-header" },
      [
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "div",
            {
              key: tab.name,
              staticClass: "tab-item",
              class: { active: _vm.activeTab === tab.name },
              on: {
                click: function ($event) {
                  return _vm.handleTabClick(tab)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")]
          )
        }),
        _c("div", { staticClass: "tab-line" }),
      ],
      2
    ),
    _c("div", { staticClass: "tab-content" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "channelInfo",
              expression: "activeTab === 'channelInfo'",
            },
          ],
          staticClass: "tab-pane",
        },
        [
          _c("ChannelInfo", {
            ref: "channelInfo",
            model: {
              value: _vm.localValue.channelInfo,
              callback: function ($$v) {
                _vm.$set(_vm.localValue, "channelInfo", $$v)
              },
              expression: "localValue.channelInfo",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "applications",
              expression: "activeTab === 'applications'",
            },
          ],
          staticClass: "tab-pane",
        },
        [
          _c("ApplicationConfig", {
            ref: "applicationConfig",
            attrs: { limits: _vm.limits, isEdit: _vm.isEdit },
            model: {
              value: _vm.localValue.applications,
              callback: function ($$v) {
                _vm.$set(_vm.localValue, "applications", $$v)
              },
              expression: "localValue.applications",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }